import { useProfile } from "@/context/ProfileContext";
import { LOGO, ADMIN_FLAG } from "@/lib/api";
import { NoisePlayer } from "@/components/NoisePlayer";
import { Heart, User, LayoutDashboard } from "lucide-react";
import { Link } from "react-router-dom";

const links = [
  { id: "scuola", label: "Scuola" },
  { id: "corredino", label: "Corredino AI" },
  { id: "catalogo", label: "Catalogo" },
  { id: "valigia", label: "Valigia ospedale" },
  { id: "crescita", label: "Crescita OMS" },
  { id: "tessuti", label: "Tessuti" },
  { id: "lista", label: "La mia lista" },
];

export default function Navbar({ onOpenList, onOpenProfile }) {
  const { profile, wishlist } = useProfile();

  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      data-testid="navbar"
      className="sticky top-0 z-40 backdrop-blur-xl bg-white/80 border-b border-[#EAE3DC]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-8 h-16 flex items-center justify-between">
        <div className="flex items-center gap-2 sm:gap-3">
          <button onClick={() => scrollTo("top")} className="flex items-center gap-2" data-testid="brand-logo">
            <img src={LOGO} alt="Minime Baby" className="h-9 sm:h-10 w-auto object-contain" />
          </button>
          <NoisePlayer />
        </div>

        <nav className="hidden lg:flex items-center gap-7">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-${l.id}`}
              onClick={() => scrollTo(l.id)}
              className="text-sm font-display text-[#5C534E] hover:text-[#C87D75] transition-colors"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          {localStorage.getItem(ADMIN_FLAG) && (
            <Link to="/admin" data-testid="nav-admin-dashboard" aria-label="Dashboard shop"
              className="inline-flex items-center gap-1.5 h-9 px-3 rounded-full border border-[#A7C4B5] text-[#4E7363] text-sm hover:bg-[#EAF0EC] transition-colors">
              <LayoutDashboard size={15} /> <span className="hidden sm:inline">Dashboard</span>
            </Link>
          )}
          {profile && (
            <button
              data-testid="open-profile-button"
              onClick={onOpenProfile}
              className="hidden sm:inline text-sm text-[#8C7F78] hover:text-[#C87D75] font-display transition-colors"
            >
              Ciao, {profile.name.split(" ")[0]}
            </button>
          )}
          {profile && (
            <button
              data-testid="open-profile-icon"
              onClick={onOpenProfile}
              aria-label="Il mio profilo"
              className="inline-flex items-center justify-center w-9 h-9 rounded-full border border-[#EAE3DC] text-[#5C534E] hover:text-[#C87D75] hover:border-[#E5A8A0] transition-colors"
            >
              <User size={16} />
            </button>
          )}
          <button
            data-testid="open-list-button"
            onClick={onOpenList}
            className="relative inline-flex items-center gap-2 rounded-full bg-[#2D2825] text-white text-sm px-4 py-2 hover:bg-[#473f3a] transition-colors"
          >
            <Heart size={15} />
            <span className="hidden sm:inline">La mia lista</span>
            {wishlist.length > 0 && (
              <span className="absolute -top-1.5 -right-1.5 bg-[#E5A8A0] text-white text-[11px] w-5 h-5 rounded-full flex items-center justify-center">
                {wishlist.length}
              </span>
            )}
          </button>
        </div>
      </div>
    </header>
  );
}
